<script setup>
import LoginContainer from '@/components/Auth/LoginContainer';
import { router } from '@inertiajs/vue3';

const props = defineProps({
    requestNewLinkUrl: {
        type: String,
        default: '/forgot-password'
    }
});

const requestNewLink = () => {
    router.visit(props.requestNewLinkUrl);
};
</script>

<template>
<LoginContainer>
    <template #title>{{ $t('auth.reset_link_expired_title') }}</template>

    <p class="mb-6">
        {{ $t('auth.reset_link_expired_message') }}
    </p>

    <div class="flex items-center gap-4">
        <StyledButton
            :full="false"
            color="primary"
            @click="requestNewLink">
            {{ $t('auth.request_new_reset_link') }}
        </StyledButton>

        <a class="router-link whitespace-nowrap" href="/login">
            {{ $t('auth.back_to_sign_in') }}
        </a>
    </div>
</LoginContainer>
</template>

